<template>
  <div>
    <credenciamento-execucao-fornecedor-vazio v-if="!temDemanda" @atualizar="buscarDemandas"/>
    <div v-else>
      <credenciamento-execucao-fornecedor-tabela/>
    </div>
  </div>
</template>

<script>

import actionTypes from "@/commons/constants/action-types";
import PaginacaoTabela from "@/commons/components/PaginacaoTabela.vue";
import CredenciamentoExecucaoFornecedorTabela
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/execucao/CredenciamentoExecucaoFornecedorTabela.vue";
import CredenciamentoExecucaoFornecedorVazio
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/execucao/CredenciamentoExecucaoFornecedorVazio.vue";

export default {
      name: "CredenciamentoExecucaoFornecedor",
      components: {PaginacaoTabela, CredenciamentoExecucaoFornecedorTabela, CredenciamentoExecucaoFornecedorVazio},
      data(){
        return {
          demandas: [],
          temDemanda: false,
          credenciamentoId: null,
          totalItens: 0,
          totalPaginas: 0,
          paginacaoInterna: {
            groupBy: [],
            groupDesc: [],
            rowsPerPage: 10,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: 'id',
            sortByDefault: ['id'],
            descending: false,
            sortDescDefault: [true]
          },
        }
      },
      watch: {
        paginacaoInterna: {
          async handler() {
            await this.buscarDemandas()
          },
          deep: true,
        }
      },
      async mounted(){
        this.credenciamentoId = this.$route.params.id;
        await this.buscarDemandas()
      },
      methods: {
        async buscarDemandas(){
          const dados = {
            credenciamentoId: this.credenciamentoId,
            fornecedorId: this.$store.state.loki.user.domainId,
            paginacao: this.paginacaoInterna,
          }

          const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDAS_CREDENCIAMENTO, dados)

          if (response && response.itens && response.itens.length > 0) {
            this.temDemanda = true
            this.totalItens = response.totalElements;
            this.totalPaginas = response.totalPages;
            this.demandas = response.itens;
          } else {
            this.temDemanda = false
            this.demandas = []
          }
        },
        setCredenciamentoId() {
          this.credenciamentoId = this.$route.params.id;
        },
      },
    }

</script>

<style scoped lang="stylus">

</style>